import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export type FlowConnectorType = 'T' | 'L' | '|';

@Component({
  selector: 'ts-flow-connector',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="relative min-w-10 min-h-5 w-full h-full overflow-hidden">
      @switch (type) {
        @case ('|') {
          <div class="absolute w-10 h-full border-left top-0 border-color"></div>
        }
        @case ('L') {
          <div
            class="absolute rounded-bl w-full h-full border-left border-bottom border-color"
            [ngStyle]="{ top: connectingLineHeight }"
          ></div>
        }
        @case ('T') {
          <div
            class="absolute w-full h-full border-left border-bottom border-color"
            [ngStyle]="{ top: connectingLineHeight }"
          ></div>
          <div class="absolute w-full h-full border-left border-color"></div>
        }
      }
    </div>
  `,
  styles: [
    `
      .border-color {
        @apply border-gray-200;
      }

      .border-left {
        border-left-width: 2.5px;
      }

      .border-bottom {
        border-bottom-width: 2.5px;
      }
    `,
  ],
})
export class TsFlowConnectorComponent {
  @Input() type: FlowConnectorType = '|';
  @Input() horizontalLineOffset = '0';

  get connectingLineHeight(): string {
    return `calc(-50%)`;
  }
}
